export default "__VITE_ASSET__DXLY3WRr__"